import { useCallback, useEffect, useMemo, useState } from 'react';

interface Props {
  pixelUrls: string[] | null;
  handleAllPixelLoaded: () => void;
}

export const useLoadPixels = ({ pixelUrls, handleAllPixelLoaded }: Props) => {
  const [currentPixelIndex, setCurrentPixelIndex] = useState(0);

  const handlePixelLoaded = useCallback(() => {
    setCurrentPixelIndex((prev) => prev + 1);
  }, []);

  const shouldRenderPixel = useMemo(() => {
    return (
      Array.isArray(pixelUrls) &&
      pixelUrls.length > 0 &&
      currentPixelIndex < pixelUrls.length
    );
  }, [pixelUrls, currentPixelIndex]);

  useEffect(() => {
    if (pixelUrls && currentPixelIndex >= pixelUrls.length) {
      handleAllPixelLoaded();
      setCurrentPixelIndex(0);
    }
  }, [currentPixelIndex, handleAllPixelLoaded, pixelUrls]);

  return { currentPixelIndex, shouldRenderPixel, handlePixelLoaded };
};
